import React, { useEffect, useRef } from 'react';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';

import Card from 'client/components/searchPage/results/Card';

const TopArticle = ({
  setRef,
  visible,

  top,
  isFetching,
  loadDetail,
  collapseMandateBanner,
  viewport,
  setCurrentFloorplan,
  userLogIn,
  cardProps,
}) => {
  const element = useRef(null);

  useEffect(() => {
    setRef(element.current);
  }, [element, setRef]);

  useEffect(() => {
    if (visible) {
      trackGTMEvents({
        category: 'NoFewResults',
        action: 'ScrollToSeePropertiesAround',
      }, null, true);
    }
  }, [visible]);

  return (
    <div ref={element} className="fill_no__top">
      {top.map(article => (
        <Card
          key={`article_${article.id}`}
          article={article}
          isSixth={false}
          isFetching={isFetching}
          loadDetail={loadDetail}
          collapseMandateBanner={collapseMandateBanner}
          viewport={viewport}            
          isFillin
          setCurrentFloorplan={setCurrentFloorplan}
          userLogIn={userLogIn}
          {...cardProps}
        />
      ))}
    </div>
  );
};

export default TopArticle;